export default {
  // Common
  scroll: 'SCROLL',
  tax_included: '(Tax Incl.)',
  tax_note: 'Tax Incl.',
  yen: 'JPY',
  yen_suffix: '',
  currency_suffix: 'JPY',
  other_items: 'Please check other items at the counter',

  // Navbar
  nav_home: 'HOME',
  nav_menu: 'MENU',
  nav_about: 'About',
  nav_access: 'Access',
  nav_reservation: 'Reservation',
  nav_lang_ja: 'JAPANESE',
  nav_lang_en: 'ENGLISH',

  // Hero
  hero_subtitle: '匠の味',
  hero_title: '貴寿司',

  // Concept
  concept_label: 'CONCEPT',
  concept_title: 'Time-Honed Mastery',
  concept_desc: 'The essence of Edomae sushi lies in its craft. Premium rice, fragrant nori, aging, curing, and marinating — each step draws out the full flavor of the ingredients. Savor the authentic art of the sushi master, crafted before your eyes.',
  concept_jcb: 'Featured in JCB THE PREMIUM',

  // Menu
  menu_label: 'MENU',
  menu_title: 'Our Menu',
  lunch_title: 'LUNCH',
  lunch_time: '11:30 - 14:00 (L.O. 13:30)',
  lunch_barachirashi: 'Bara Chirashi',
  lunch_barachirashi_price: '1500',
  lunch_tekkadon: 'Tekka Don',
  lunch_tekkadon_price: '2000',
  course_title: 'Course Menu',
  course_subtitle: 'Appetizer · Starter · Sashimi · Grilled (Simmered) Fish · Tempura ·\nSushi (Nigiri or Chirashi) · Soup, etc.',
  course_um: 'Ume',
  course_um_price: '7700',
  course_take: 'Take',
  course_take_price: '11000',
  course_matsu: 'Matsu',
  course_matsu_price: '14300',
  nigiri_title: 'Nigiri Sushi',
  nigiri_subtitle: 'NIGIRI',
  nigiri_nami: 'Nami',
  nigiri_nami_price: '3300',
  nigiri_jo: 'Jo',
  nigiri_jo_price: '4400',
  nigiri_tokujo: 'Tokujo',
  nigiri_tokujo_price: '6600',
  nigiri_omakase: 'Omakase',
  nigiri_omakase_price: '9900',
  maguro_title: 'Tuna Sushi',
  maguro_subtitle: 'MAGURO',
  maguro_tekkaju: 'Tekka Ju',
  maguro_tekkaju_price: '3300',
  maguro_chutoroju: 'Chutoro Ju',
  maguro_chutoroju_price: '5500',
  maguro_akaminigiri: 'Akami Nigiri',
  maguro_akaminigiri_price: '3300',
  maguro_chutoronigiri: 'Chutoro Nigiri',
  maguro_chutoronigiri_price: '5500',
  sake_title: 'Japanese Sake',
  sake_subtitle: 'JAPANESE SAKE',
  sake_desc: 'We offer a curated selection of regional sake from across Japan.\nRare brands directly sourced from breweries are also available.\nEnjoy them alongside seasonal sushi and cuisine.',
  maki_title: 'Maki Rolls',
  maki_subtitle: 'MAKIMONO',
  maki_items: 'Nori Maki,Kappa Maki,Oshinko Maki,Gobo Maki,Natto Maki,Ume Shiso Maki,Tekka Maki,Toro Maki,Negi Toro Maki,Toro Taku Maki,Futo Maki,Nori Tama,Kids Sushi',
  menu_reservation: 'Reserve a Seat',
  menu_phone: '03-3980-5537',
  menu_phone_note: '(Except closed days)',

  // About / Kodawari
  about_label: 'About',
  about_title: 'The Essence of Edomae Sushi Lies in Craft.',
  about_subtitle: 'Discover the flavors woven from traditional techniques and seasonal ingredients.',
  techniques_title: 'Discover the flavors woven from traditional techniques and seasonal ingredients.',
  technique_shari_title: 'Premium Silver Rice',
  technique_shari_desc: 'The rice is the lifeblood of Edomae sushi. At Takazushi, every grain stands proud, with careful attention to the balance of vinegar to bring out the rice\'s own umami.',
  technique_jukusei_title: 'Aging',
  technique_jukusei_desc: 'Seafood, including tuna, is aged at optimal temperature and humidity. This removes excess moisture and increases inosinic acid, deepening the flavor. Each fish is assessed to determine its ideal aging period.',
  technique_shimeru_title: 'Curing & Marinating',
  technique_shimeru_desc: 'Mackerel and kohada are cured in vinegar and salt to concentrate umami. Ikura is marinated in our special soy sauce blend, each roe gleaming like a jewel. Traditional techniques passed down through generations, refined with modern sensibility.',
  sourcing_title: 'Sourcing & Ingredients',
  sourcing_subtitle: 'SOURCING',
  sourcing_market_title: 'Daily Market Selection',
  sourcing_market_desc: 'We visit Toyosu Market every morning to personally select the finest fish of the day. Long-standing relationships with trusted intermediaries ensure consistent quality.',
  sourcing_season_title: 'Seasonal Direct Delivery',
  sourcing_season_desc: 'Sea urchin from Hokkaido, sea bream from Akashi, conger eel from Tsushima — direct from producers across Japan. We cherish the natural flavor of each ingredient and avoid excessive manipulation, with a commitment to quality.',
  sourcing_condiments_title: 'Rice, Vinegar & Soy Sauce',
  sourcing_condiments_desc: 'The essence of sushi lies in three things: rice, vinegar, and soy sauce. The rice is cooked into fluffy silver rice. With careful attention to vinegar and soy sauce, the natural umami of every ingredient is drawn out.',
  about_cta: 'Reserve a Seat',

  // Access
  access_label: 'ACCESS',
  access_title: 'Store Information & Access',
  info_title: 'Store Information',
  info_subtitle: 'INFORMATION',
  info_name: 'Store Name',
  info_name_val: 'Takazushi',
  info_address: 'Address',
  info_address_val: '2-9-18 Minami-Ikebukuro, Toshima-ku, Tokyo 171-0022',
  info_phone: 'Phone',
  info_phone_val: '03-3980-5537',
  info_hours: 'Hours',
  info_hours_val: 'Lunch 11:30 - 14:00 (L.O. 13:30)\nDinner 17:00 - 22:00 (L.O. 21:30)',
  info_closed: 'Closed',
  info_closed_val: 'Mondays',
  info_seats: 'Seats',
  info_seats_val: 'Counter 8 seats / Tatami room 12 seats / 2F Tatami room 22 seats',
  info_payment: 'Payment',
  info_payment_val: 'Cash / Credit Cards (VISA, MasterCard, AMEX, JCB, Diners)',
  guidelines_title: 'Guidelines',
  guidelines_subtitle: 'GUIDELINES',
  guideline_dress_title: 'Dress Code',
  guideline_dress_desc: 'No strict dress code, but we kindly ask that you refrain from strong perfumes or hair products, as they may interfere with the delicate aroma of the sushi.',
  guideline_time_title: 'Dining Duration',
  guideline_time_desc: 'Lunch approx. 90 min, Dinner approx. 120 min.\nDue to course timing, arriving 15+ minutes late may result in some dishes being omitted.',
  guideline_cancel_title: 'Cancellation Policy',
  guideline_cancel_desc: 'Cancellations: 50% charge the day before, 100% charge on the day.\nPlease notify us of any changes by the day before.',
  guideline_allergy_title: 'Allergies & Dietary Restrictions',
  guideline_allergy_desc: 'Same-day accommodation may be difficult. Please inform us at the time of reservation.\nWe will substitute ingredients where possible.',
  access_cta_text: 'Feel free to contact us with any access inquiries',
  access_reservation: 'Reserve a Seat',

  // StoreInfo (Home)
  storeinfo_label: 'INFORMATION',
  storeinfo_title: 'Visit Us',
  storeinfo_hours: 'Hours',
  storeinfo_hours_lunch: 'Lunch 11:30 - 14:00',
  storeinfo_hours_lunch_lo: '(L.O. 13:30)',
  storeinfo_hours_dinner: 'Dinner 17:00 - 22:00',
  storeinfo_hours_dinner_lo: '(L.O. 21:30)',
  storeinfo_closed: 'Closed: Mondays',
  storeinfo_access: 'Access',
  storeinfo_access_val: '2-9-18 Minami-Ikebukuro, Toshima-ku, Tokyo 171-0022',
  storeinfo_contact: 'Contact',
  storeinfo_contact_phone: '03-3980-5537',
  storeinfo_contact_note: '(Except closed days)',
  storeinfo_reservation: 'Reserve a Seat',

  // Reservation
  reservation_label: 'RESERVATION',
  reservation_title: 'Reservation',
  reservation_subtitle: 'Reservations are accepted by phone.',
  reservation_phone_title: 'Reservations by Phone',
  reservation_phone: '03-3980-5537',
  reservation_phone_note: '(Except closed days)',
  reservation_note: 'Please provide the following information when making a reservation.',
  reservation_tag_date: 'Preferred Date & Time',
  reservation_tag_people: 'Number of Guests',
  reservation_tag_allergy: 'Allergies',

  // Footer
  footer_nav_title: 'NAVIGATION',
  footer_nav_home: 'HOME',
  footer_nav_menu: 'MENU',
  footer_nav_about: 'About',
  footer_nav_access: 'Access',
  footer_nav_reservation: 'Reservation',
  footer_info_title: 'INFO',
  footer_address: '2-9-18 Minami-Ikebukuro, Toshima-ku, Tokyo 171-0022',
  footer_tel: 'Tel. 03-3980-5537',
  footer_hours_lunch: 'Lunch 11:30 - 14:00 (L.O. 13:30)',
  footer_hours_dinner: 'Dinner 17:00 - 22:00 (L.O. 21:30)',
  footer_closed: 'Closed: Mondays',
  footer_copyright: '© {{year}} Takazushi. All Rights Reserved.',
};